import { useState } from "react";
import LaunchingAppDialog from "./read-offline/LaunchingAppDialog.tsx";
import MyAccount from "./MyAccount.tsx";
import QrCodeDialogSwitcher from "../../../actions/qrcode/QrCodeDialogSwitcher.tsx";
import PublisherPrefsDialog from "../../../actions/publisher-prefs/PublisherPrefsDialog.tsx";

export default function MyAccountDialogSwitcher({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) {
  const [activeDialog, setActiveDialog] = useState<
    "my-account" | "qr-code" | "download-app" | "publisher-prefs"
  >("my-account");

  if (activeDialog === "my-account") {
    return (
      <MyAccount
        onRequestClose={onRequestClose}
        onOpenQrDialog={() => setActiveDialog("qr-code")}
        onOpenAppDialog={() => setActiveDialog("download-app")}
        onOpenPublisherPrefsDialog={() => setActiveDialog("publisher-prefs")}
      />
    );
  }
  if (activeDialog === "qr-code") {
    return <QrCodeDialogSwitcher onRequestClose={onRequestClose} />;
  }
  if (activeDialog === "download-app") {
    return <LaunchingAppDialog onRequestClose={onRequestClose} />;
  }
  if (activeDialog === "publisher-prefs") {
    return <PublisherPrefsDialog onRequestClose={onRequestClose} />;
  }
}
